<div class="footer-container">
    <p *ngIf="franchiseeDetails.franchisee" class="mx-auto my-auto">
        &#169; {{ year }} - Licensed to {{ tenantDetails.name }}, a franchisee of Beyond Credit
    </p>
    <p *ngIf="!franchiseeDetails.franchisee" class="mx-auto my-auto">
        &#169; {{ year }} - Licensed to {{ tenantDetails.name }}
    </p>
</div>